import React, { useEffect, useRef, useState } from 'react';
import './form-builder.styles.scss';
import '@/components/SHARED/form-builder/01-manage-forms.styles.scss';
import ManageForms from '@/components/SHARED/form-builder/01-manage-forms.component';
import { Route, Routes, useNavigate } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { ModalAlert, ModalConfirm } from '@/components/SHARED/modal/modal.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import FormLinkCreator from './form-link-creator.component';
import FormLinkList from './form-link-list.component';
import { format } from 'date-fns';
import FormTemplateList from '@/components/SHARED/form-builder/form-template-list.component';
import { getCollectionFromFirestore } from '../../../utils/getDataFromDbSimplified';
import ManageQuestionSets from '../../SHARED/form-builder/manage-question-sets.component';
import CreateQuestionSet from '../../SHARED/form-builder/create-question-set.compnent';
import { UseCloudAdminFunction } from '../../../utils/firebase.utils';

const FormBuilder = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.listsData.screenSize);
  const [formTemplates, setFormTemplates] = useState([]);
  const [ formLinks, setFormLinks ] = useState({});
  const [questionSets, setQuestionSets] = useState([]);
  const [selectedQuestionSet, setSelectedQuestionSet] = useState(null);
  const [chosenQuestionSets, setChosenQuestionSets] = useState([]);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [externalForms, setExternalForms] = useState([]);
  const [visibleTemplates, setVisibleTemplates] = useState(5);
  const [visibleQuestionSets, setVisibleQuestionSets] = useState(5);
  const navigate = useNavigate();
  const approveRef = useRef(null);
  const dataRef = useRef({});
  const setsRef = useRef({});
  const formsRef = useRef({});
  const formLinksRef = useRef({});
  let setsListener;
  let formsListener;

  useEffect(() => {

    return () => {
      if (setsListener) setsListener();
      if (formsListener) formsListener();
    }
  }, [])

  useEffect(() => {
    if (!userProfile) return;
    getFormsData();
  }, [userProfile])

  function getFormsData() {
    getCollectionFromFirestore({
      'path': 'forms_data',
      'callback': callback,
      'handleListener': handleListener,
    });
    function callback(data) {
      if (data.status !== 'active') return;
      if (data.type === 'formData') {
        formsRef.current = {
          ...formsRef.current,
          ...{ [data.id]: data }
        }
        setFormTemplates(formsRef.current);
      } else if (data.type === 'questionSet') {
        setsRef.current = {
          ...setsRef.current,
          ...{ [data.id]: data }
        }
        setQuestionSets(setsRef.current);
      } else if (data.type === 'formLink') {
        formLinksRef.current = {
          ...formLinksRef.current,
          ...{ [data.id]: data }
        }
        setFormLinks(formLinksRef.current);
      }
    }

    function handleListener(unsub) {
      formsListener = unsub;
    }
  }

  async function saveForm(formData) {
    const tempForm = { ...formData };
    if (!tempForm.name || chosenQuestionSets.length === 0) {
      setAlertMessage('Please provide a form name and select at least one question set.');
      return;
    }
    setLoading(true);
    tempForm.questionSets = chosenQuestionSets;
    tempForm.type = 'formData';
    console.log('Save Form', tempForm);
    const res = await UseCloudFunction(
      'saveFormsData',
      {
        'formsData': tempForm,
        'userProfile': userProfile,
      }
    )
    console.log(res);
    if (res.error) {
      setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
      return;
    }
    setLoading(false);
    navigate('/admin/settings/forms');
  }

  function archiveQuestionSet() {
    // Archive logic here
    const tempData = { ...selectedQuestionSet };

    setConfirmMessage(`Are you sure you want to archive the question set "${tempData.name}"?`);
    approveRef.current = () => {
      continueArchive(tempData);
    }

    async function continueArchive(tempData) {
      tempData.status = 'archived';
      const res = await UseCloudFunction(
        'saveFormsData',
        {
          'formsData': tempData,
          'userProfile': userProfile
        }
      );
      if (res.error) {
        console.error('Error archiving question set:', res.error);
        setConfirmMessage(null);
        return;
      }
    }

  }

  async function saveQuestionSet(setData, finalSave = false) {
    const tempSet = { ...setData };
    tempSet.type = 'questionSet';
    if (
      !tempSet.name ||
      !tempSet.displayName ||
      !tempSet.questions ||
      Object.values(tempSet.questions).length === 0
    ) {
      setAlertMessage('Please provide a valid question set name, display name, and at least one question.');
      return;
    }
    setLoading(true);
    console.log(tempSet);
    // return;
    const res = await UseCloudAdminFunction(
      'saveFormsData',
      {
        "formsData": tempSet,
        "userProfile": userProfile
      }
    )
    console.log('Save Question Set Result', res);
    if (res.error) {
      setAlertMessage(`Error saving question set: ${res.error.message}`);
      return;
    }
    setLoading(false);
    if (finalSave) {
      navigate(-1);
    }
  }

  return (
    <div className='admin-form-creator'>
      <div className='admin-form-creator-content'>
        <div className={screenSize === 'mobile' ? 'g-mobile-card' : 'g-card'}>
        <Routes>
          <Route path='' element={
            <ManageQuestionSets 
              questionSets={questionSets}
              archiveQuestionSet={archiveQuestionSet} />
          }></Route>
          <Route path="create" element={
            <>
              <BackButton cancel={() => navigate(-1)} />
              <div className="g-space-1"></div>
              <CreateQuestionSet
                saveQuestionSet={saveQuestionSet}
                questionSets={questionSets}
                chosenQuestionSets={chosenQuestionSets}
                setChosenQuestionSets={setChosenQuestionSets} />
            </>
          }></Route>
          <Route path='edit/:setId' element={
            <>
              <BackButton cancel={() => navigate(-1)} />
              <div className="g-space-1"></div>
              <CreateQuestionSet
                setAlertMessage={setAlertMessage}
                saveQuestionSet={saveQuestionSet}
                questionSets={questionSets}
                approveRef={approveRef} />
            </>
            }></Route>
          
        </Routes>
        </div>
      </div>
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default FormBuilder